import { hasOwnProperty } from "@ciaopeople/cp-shatsu/Utils";
import { isObject } from "@ciaopeople/cp-shatsu/TypeChecking";

export enum UserActionErrorCode {

    UNKNOWN_ERROR = 0,
    LOGIN_REQUIRED = 1,
    PARAMETER_ERROR = 2
    
}

export enum UserActionIdentifier {
    GENERIC_CALL = 0,
    FOLLOW = 1,
    BOOKMARK = 2,
    LOGIN = 3,
    NEWSLETTER_SUBSCRIBE = 4
}

export interface UserActionError {

    code: UserActionErrorCode,
    action: UserActionIdentifier,
    message?: string,
    data?: any
}

export function isUserActionError(obj: any): obj is UserActionError {

    return isObject(obj) && hasOwnProperty(obj, "code") && hasOwnProperty(obj, "action");

}